import React from 'react'
import { IMG_BASE_URL } from '../../config/Base_Url_Config'

const Web_Development_Projects = (get_development_list) => {
    const development_list = get_development_list && get_development_list?.data;
    return (
        <div>
            <section className="relative">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="flex flex-wrap items-center justify-between max-w-2xl lg:max-w-full mb-12">
                        <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
                            <h2 className="text-3xl md:text-4xl font-bold">
                                <span className="text-blue-500">
                                    {development_list?.development_heading?.title}
                                </span>
                            </h2>
                        </div>
                        <div className="w-full lg:w-1/2">
                            <p>{development_list?.development_heading?.description}</p>
                        </div>
                    </div>

                    {/* Process Grid */}
                    <div className="flex flex-wrap -mx-3 -mb-6 text-center">
                        {development_list?.development_process?.map((step, index) => {
                            return (
                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                    <div className="p-12 bg-white shadow rounded">
                                        <div className="flex w-12 h-12 mx-auto items-center justify-center text-blue-800 font-bold font-heading bg-blue-200 rounded-full">
                                            {index + 1}
                                        </div>
                                        <img className="h-36 mx-auto my-4" src={`${IMG_BASE_URL}/${step?.image}`} alt={step.title} />
                                        <h3 className="mb-2 font-bold text-xl">{step?.title}</h3>
                                        <p className="text-gray-600 mb-4 transition-all duration-300 ease-in-out">
                                            {step?.description}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Web_Development_Projects
